export const hasData = response => {
	if (response && response.data) {
		return response.data;
	}
	throw new Error('response.data does not exist.');
};
